var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"badge-component",attrs:{"variant":_vm.variant}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }